import {styled} from '../../../utils';
import Layout from '../../Layout';

export default styled(Layout)(({theme}) => ({
  minHeight: '100vh',
  paddingLeft: theme.globalSider.width
}));



// WEBPACK FOOTER //
// ./src/components/GlobalLayout/MainContainer/MainContainer.tsx